import { StyleSheet, Text, View, ScrollView } from 'react-native'

// styles
import { colorPalette, globalStyles } from '../static/styles/global'
import { skeletonStyles } from '../static/styles/skeleton'

// components
import Card from '../components/shared/card/Card'
import CardSeparator from '../components/shared/card/CardSeparator'
import MyScrollView from '../components/shared/navigator/MyScrollView'

const PersonalBasicInfoSkeleton = () => {
  return (
    <MyScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[skeletonStyles.headerNav]} />
        <View style={[globalStyles.horizontalPadGap, globalStyles.vCenterItems, globalStyles.vDirection]}>
          <View style={[skeletonStyles.headerHeading]} />
          <View style={[skeletonStyles.headerDescription]} />
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View style={[styles.cardTitle]} />
          <CardSeparator light={true} />
          <View
            style={[
              globalStyles.row,
              globalStyles.vCenterItems,
              globalStyles.mb4
            ]}
          >
            <View style={[globalStyles.colHalf, globalStyles.colLeft]}>
              <View style={[styles.cardItemInputLabel]} />
              <View
                style={[styles.cardItemInput, globalStyles.alignSelfRight]}
              />
            </View>
            <View style={[globalStyles.colHalf, globalStyles.colRight]}>
              <View style={[styles.cardItemInputLabel]} />
              <View
                style={[styles.cardItemInput, globalStyles.alignSelfRight]}
              />
            </View>
          </View>
          <View
            style={[
              globalStyles.row,
              globalStyles.vCenterItems,
              globalStyles.mb4
            ]}
          >
            <View style={[globalStyles.colFull]}>
              <View style={[styles.cardItemInputLabel]} />
              <View
                style={[styles.cardItemInput, globalStyles.alignSelfRight]}
              />
            </View>
          </View>
          <View
            style={[
              globalStyles.row,
              globalStyles.vCenterItems,
              globalStyles.mb4
            ]}
          >
            <View style={[globalStyles.colFull]}>
              <View style={[styles.cardItemInputLabel]} />
              <View
                style={[styles.cardItemInput, globalStyles.alignSelfRight]}
              />
            </View>
          </View>
          <View
            style={[
              globalStyles.row,
              globalStyles.vCenterItems,
              globalStyles.mb4
            ]}
          >
            <View style={[globalStyles.colFull]}>
              <View style={[styles.cardItemInputLabel]} />
              <View
                style={[styles.cardItemInput, globalStyles.alignSelfRight]}
              />
            </View>
          </View>
          <View
            style={[
              globalStyles.row,
              globalStyles.vCenterItems,
              globalStyles.mb4
            ]}
          >
            <View style={[globalStyles.colFull]}>
              <View style={[styles.cardItemInputLabel]} />
              <View
                style={[styles.cardItemInput, globalStyles.alignSelfRight]}
              />
            </View>
          </View>
          <View
            style={[
              globalStyles.row,
              globalStyles.vCenterItems,
              globalStyles.mb4
            ]}
          >
            <View style={[globalStyles.colFull]}>
              <View style={[styles.cardItemInputLabel]} />
              <View
                style={[styles.cardItemInput, globalStyles.alignSelfRight]}
              />
            </View>
          </View>
        </Card>
      </View>
    </MyScrollView>
  )
}

const styles = StyleSheet.create({
  cardTitle: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.6,
    width: '50%',
    padding: 8,
    borderRadius: 10,
    marginVertical: 5
  },
  cardItemInput: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.4,
    width: '100%',
    padding: 20,
    borderRadius: 10,
    alignSelf: 'flex-end'
  },
  cardItemInputLabel: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.5,
    width: '40%',
    padding: 5,
    marginBottom: 8,
    borderRadius: 10
  }
})

export default PersonalBasicInfoSkeleton
